import React, { Component } from 'react'
import './index.scss'
import logo from '../../assets/logo.png'
import topic from '../../assets/topic.png'
import TopicDialog from '../../components/Topicdialog'
export default class Topic extends Component {
  state = {
    topicId: '',
    topicName: '',
    topicArr: [
      {
        id: 114,
        name: '新质生产力',
        tag: '5_03',
      },
      {
        id: 115,
        name: '文旅融合',
        tag: '5_05',
      },
      {
        id: 116,
        name: '扩大内需',
        tag: '5_07',
      },
      {
        id: 117,
        name: '科技创新',
        tag: '5_12',
      },
      {
        id: 118,
        name: '粮食安全',
        tag: '5_13',
      },
      {
        id: 119,
        name: '数字化转型',
        tag: '5_14',
      },
      {
        id: 120,
        name: '乡村振兴',
        tag: '5_18',
      },
      {
        id: 121,
        name: '社会保障',
        tag: '5_19',
      },
      {
        id: 122,
        name: '依法治国',
        tag: '5_20',
      },
      {
        id: 123,
        name: '教育人才',
        tag: '5_24',
      },
      {
        id: 124,
        name: '国家安全',
        tag: '5_25',
      },
      {
        id: 125,
        name: '改革开放',
        tag: '5_26',
      },
      {
        id: 126,
        name: '生态文明',
        tag: '5_30',
      },
      {
        id: 127,
        name: '营商环境',
        tag: '5_31',
      },
      {
        id: 128,
        name: '就业创业',
        tag: '5_32',
      },
      {
        id: 129,
        name: '正风反腐',
        tag: '5_33',
      },
      {
        id: 130,
        name: '医疗卫生',
        tag: '5_34',
      },
      {
        id: 131,
        name: '交通运输',
        tag: '5_35',
      },
    ],
  }
  showQuestions = (topicId, topicName) => {
    this.setState({ topicId, topicName })
    this.dialogRef.show()
  }
  render() {
    const { topicId, topicName, topicArr } = this.state
    return (
      <div className="conBox bg" data-component="topic">
        {/* <img className="logo" src={logo} alt="logo" /> */}
        <img className="titleIcon" src={topic} alt="logo" />
        <ul className="mainBox">
          {topicArr.map((item,index) => (
            <li
              className={"topicItem icon"+ index}
              key={item.id}
              onClick={() => this.showQuestions(item.id, item.name)}
            >
                <div className="name">{item.name}</div>
            </li>
          ))}
        </ul>
        <TopicDialog
          ref={(c) => (this.dialogRef = c)}
          topicId={topicId}
          topicName={topicName}
        />
      </div>
    )
  }
}
